import React from 'react';
import PropTypes from 'prop-types';
import Slide from '@material-ui/core/Slide';
import Dialog from '@material-ui/core/Dialog';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import { colors } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import {closeAlert, logout } from 'actions'
import InputIcon from '@material-ui/icons/Input';
import { useSelector, useDispatch } from 'react-redux';
import {useSessionSelector} from 'reducers/sessionReducer'
import Auth from 'services/auth';

const useStyles = makeStyles(theme => ({
  message: {
    whiteSpace: 'pre-wrap',
    maxHeight: '90vh'
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: theme.spacing(2)
  },
  content: {
    padding: theme.spacing(0, 2),
    maxWidth: 720,
    margin: '0 auto'
  },
  contact: {
    margin: theme.spacing(3, 0)
  },
  actions: {
    backgroundColor: colors.grey[100],
    padding: theme.spacing(2),
    display: 'flex',
    justifyContent: 'flex-end'
  },
  deleteButton: {
    color: theme.palette.white,
    backgroundColor: colors.red[600],
    '&:hover': {
      backgroundColor: colors.red[900]
    }
  }
}));

const Dialog401 = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { open, type } = useSelector(state => state.alert);
  const {user} = useSessionSelector()

  const handleClose = (event, reason) => {
    if (reason === 'backdropClick') {
      return;
    }
    dispatch(closeAlert())
  };

  const handleLogout = async () => {
    try {
      if(user.loginID) {
        await Auth.logout(user.loginID);
      }
      dispatch(logout());
      handleClose();
    } finally {
      self.close();
    }
  }

  const isOpen = type === '401' && open;

  return (
    <Dialog
      TransitionComponent={Slide}
      fullWidth
      maxWidth="sm"
      open={isOpen}
    >
      <div className={classes.header}>
        <Typography variant="h3">
          Your session has timed out
        </Typography>
      </div>
      <Divider />
      <div className={classes.content}>
        <Typography
          align="center"
          className={classes.contact}
          variant="subtitle1"
        >
          Please press OK to close the current Dashboard tab, return to the application, and restart Dashboard.
        </Typography>
      </div>
      <div className={classes.actions}>
        <Button
          className={classes.deleteButton}
          endIcon={<InputIcon />}
          onClick={handleLogout}
          variant="contained"
        >
          Ok
        </Button>
      </div>
    </Dialog>
  );
}

Dialog401.propTypes = {
  className: PropTypes.string
};

export default Dialog401;
